import * as React from 'react'
import cn from 'classnames'
import { FilePdfOutlined } from '@ant-design/icons'
import { IAttachments } from '@core/api/Products/types'
import { LYSIcon } from '@core/components/Primitives'
import style from '@core/components/ProductDetail/Attachments/index.module.less'

export interface AttachmentItemProps {
  attachment: IAttachments
  className?: string
}

export const AttachmentItem: React.FC<AttachmentItemProps> = (props) => {
  const { attachment, className } = props

  return (
    <div className={cn(style.attachmentItem, className)}>
      <a
        target="blank"
        rel="noopener noreferrer"
        href={attachment.url}
        download={true}
      >
        <LYSIcon className={style.icon} component={FilePdfOutlined} />
        {attachment.name}
      </a>
    </div>
  )
}
